import React, {forwardRef} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TStateSetter} from 'shared/types/generics';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {publishAisDocumentsInInterface} from 'store/slices/ais-slice/ais-slice-thunks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';

interface IPublishConfirmationModalProps {
    refetchTableData: () => void;
    organizationId: number | undefined;
}

export const PublishConfirmationModal = forwardRef<IModalOpenerComponentRef, IPublishConfirmationModalProps>((
    {refetchTableData, organizationId}: IPublishConfirmationModalProps,
    ref,
) => {
    const dispatch = useAppDispatch();

    const isDeleting = useAppSelector(s => selectIsThunkPending(s, publishAisDocumentsInInterface.typePrefix));

    const handleDelete = (setIsModalOpen: TStateSetter<boolean>) => {
        dispatch(publishAisDocumentsInInterface({orgId: organizationId!})).unwrap().then(() => {
            showMessage({message: 'Программа запущена успешно'});
            setIsModalOpen(false);
            refetchTableData();
        }, error => {
            const {data: responseMessage, status} = error?.response;
            const isBadRequest = status === 400;
            const message = isBadRequest && responseMessage
                ? responseMessage : 'Во время запуска программы публикаций записей произошла ошибка';
            showMessage({message, isError: true});
            setIsModalOpen(false);
        });
    };

    return (
        <ModalOpenerComponent
            ref={ref}
            modalProps={{
                forceRender: false,
                destroyOnClose: true,
                title: 'Предупреждение',
                centered: true,
            }}
            controlLabels={{
                save: 'Да',
                cancel: 'Нет',
            }}
            loadingControls={{
                save: isDeleting,
            }}
            disabledControls={{
                save: isDeleting,
            }}
            handleSave={setIsModalOpen => {
                handleDelete(setIsModalOpen);
            }}
        >
            Вы уверены, что хотите опубликовать документы?
        </ModalOpenerComponent>
    );
});
